import Big from 'big.js'

import { sortByWalletBalances } from '../utils/sort'

import { useSort } from './useSort'

const useSortSynthetics = (debtBalances, path = '') =>
  useSort({
    defaultSort: 'asset-asc',
    path,
    sortKey: 'sort-synthetics',
    sortTypes: [
      {
        defaultSort: 'asc',
        sortFn: (a, b) =>
          a.symbol.toLowerCase().localeCompare(b.symbol.toLowerCase()),
        type: 'asset'
      },
      {
        defaultSort: 'asc',
        sortFn: (a, b) => Big(a.interestRate).cmp(b.interestRate),
        type: 'interest-rate'
      },
      {
        defaultSort: 'asc',
        sortFn: sortByWalletBalances('syntheticBalance'),
        type: 'synthetic'
      },
      {
        defaultSort: 'asc',
        sortFn: sortByWalletBalances('debtBalance'),
        type: 'debt'
      }
    ]
  })

export default useSortSynthetics
